import * as notification from '../../actionTypes/Notifications/notification'
const initialState = {
  notification: {
    bannerMessages: {
      UndergoMaintenanceOn: '',
      Submessages: []
    },
    DisplayMaintenanceBanner: false,
    status: false
  }
}

export default function NotificationBanner (state = initialState, action) {
  switch (action.type) {
    case notification.GET_DISPLAY_MAINTENANCE_BANNER:
      state.notification = action.payload
      return {
        ...state
      }
    case notification.HIDE_DISPLAY_MAINTENANCE_BANNER:
      return {
        ...state,
        notification: {
          ...state.notification,
          DisplayMaintenanceBanner: action.payload,
          bannerMessages: {
            UndergoMaintenanceOn: '',
            Submessages: []
          },
          status: false
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/store/notification.js